import React from 'react';
import {Link} from 'react-router-dom';
import {LearningLesson, learningCount, learningLessonUrl, learningStatusLabel} from './learning';

export default function LessonCard({lesson}: {lesson: LearningLesson}) {
    return <Link to={learningLessonUrl(lesson)} className='learning-lesson-card'>
        <span className='learning-lesson-art' aria-hidden='true'>
            <svg viewBox='0 0 32 32' fill='none'><path d='M6 6.5h8.5a4 4 0 0 1 4 4V26H10a4 4 0 0 0-4 2V6.5Z' stroke='currentColor' strokeWidth='1.8' strokeLinejoin='round'/><path d='M26 6.5h-3a4 4 0 0 0-4 4V26h3a4 4 0 0 1 4 2V6.5Z' stroke='currentColor' strokeWidth='1.8' strokeLinejoin='round'/></svg>
        </span>
        <span className='learning-lesson-copy'>
            <strong>{lesson.title}</strong>
            <span className='learning-lesson-meta'>
                {lesson.duration && <span>{lesson.duration}</span>}
                {lesson.questionCount > 0 && <span>{learningCount(lesson.questionCount, 'вопрос', 'вопроса', 'вопросов')}</span>}
                {lesson.status !== 'passed' && lesson.rewardCoins !== null && lesson.rewardCoins > 0 && <span>до {lesson.rewardCoins} ЧиоКоинов</span>}
            </span>
        </span>
        <span className={`learning-status is-${lesson.status}`}>{learningStatusLabel(lesson.status)}</span>
        <span className='learning-card-arrow' aria-hidden='true'>›</span>
    </Link>;
}
